/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AcceptContract200,
  Activate200,
  AddAddendum200,
  AddContractLine200,
  AddContractLineRequest,
  AddendumRequest,
  CancelContract200,
  CloseContract200,
  Complete200,
  Contract,
  ContractLine,
  CreateContract200,
  CreateContractFromOfferByClient200,
  CreateContractFromOfferByClientRequest,
  CreateContractFromOfferRequest,
  CreateContractRequest,
  CreateFromOffer200,
  DeactivateContract200,
  GetContract200,
  GetContractHistory200,
  GetContractPdf200,
  Hold200,
  PagedResponseContract,
  RejectContract200,
  RejectContractRequest,
  RemoveContractLine200,
  SaveContractLines200,
  SaveContractLinesRequest,
  SearchContractsParams,
  SendContract200,
  UpdateContract200,
  UpdateContractLine200,
  UpdateContractLineRequest,
  UpdateContractRequest
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary List a contract's lines, including historical addendum-superseded ones
 */
export const listContractLines = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ContractLine[]>(
      {url: `/api/v1/contracts/${id}/lines`, method: 'GET', signal
    },
      );
    }
  



export const getListContractLinesQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/${id}/lines`
    ] as const;
    }

    
export const getListContractLinesQueryOptions = <TData = Awaited<ReturnType<typeof listContractLines>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContractLinesQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContractLines>>> = ({ signal }) => listContractLines(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListContractLinesQueryResult = NonNullable<Awaited<ReturnType<typeof listContractLines>>>
export type ListContractLinesQueryError = unknown


export function useListContractLines<TData = Awaited<ReturnType<typeof listContractLines>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractLines>>,
          TError,
          Awaited<ReturnType<typeof listContractLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractLines<TData = Awaited<ReturnType<typeof listContractLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractLines>>,
          TError,
          Awaited<ReturnType<typeof listContractLines>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractLines<TData = Awaited<ReturnType<typeof listContractLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List a contract's lines, including historical addendum-superseded ones
 */

export function useListContractLines<TData = Awaited<ReturnType<typeof listContractLines>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractLines>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListContractLinesQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Save all line changes (remove/update/add) in one transaction — only while DRAFT or REJECTED
 */
export const saveContractLines = (
    id: string,
    saveContractLinesRequest: SaveContractLinesRequest,
 ) => {
      
      
      return apiClient<SaveContractLines200>(
      {url: `/api/v1/contracts/${id}/lines`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveContractLinesRequest
    },
      );
    }
  


export const getSaveContractLinesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveContractLines>>, TError,{id: string;data: SaveContractLinesRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof saveContractLines>>, TError,{id: string;data: SaveContractLinesRequest}, TContext> => {

const mutationKey = ['saveContractLines'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveContractLines>>, {id: string;data: SaveContractLinesRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  saveContractLines(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveContractLinesMutationResult = NonNullable<Awaited<ReturnType<typeof saveContractLines>>>
    export type SaveContractLinesMutationBody = SaveContractLinesRequest
    export type SaveContractLinesMutationError = unknown

    /**
 * @summary Save all line changes (remove/update/add) in one transaction — only while DRAFT or REJECTED
 */
export const useSaveContractLines = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveContractLines>>, TError,{id: string;data: SaveContractLinesRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveContractLines>>,
        TError,
        {id: string;data: SaveContractLinesRequest},
        TContext
      > => {

      const mutationOptions = getSaveContractLinesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Add a line to a contract — only while DRAFT or REJECTED
 */
export const addContractLine = (
    id: string,
    addContractLineRequest: AddContractLineRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddContractLine200>(
      {url: `/api/v1/contracts/${id}/lines`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addContractLineRequest, signal
    },
      );
    }
  


export const getAddContractLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContractLine>>, TError,{id: string;data: AddContractLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addContractLine>>, TError,{id: string;data: AddContractLineRequest}, TContext> => {

const mutationKey = ['addContractLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addContractLine>>, {id: string;data: AddContractLineRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  addContractLine(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddContractLineMutationResult = NonNullable<Awaited<ReturnType<typeof addContractLine>>>
    export type AddContractLineMutationBody = AddContractLineRequest
    export type AddContractLineMutationError = unknown

    /**
 * @summary Add a line to a contract — only while DRAFT or REJECTED
 */
export const useAddContractLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addContractLine>>, TError,{id: string;data: AddContractLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addContractLine>>,
        TError,
        {id: string;data: AddContractLineRequest},
        TContext
      > => {

      const mutationOptions = getAddContractLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary List contracts for the caller's organisation
 */
export const listContracts = (
    
 signal?: AbortSignal
) => {
      
      
      return apiClient<Contract[]>(
      {url: `/api/v1/contracts`, method: 'GET', signal
    },
      );
    }
  



export const getListContractsQueryKey = () => {
    return [
    `/api/v1/contracts`
    ] as const;
    }

    
export const getListContractsQueryOptions = <TData = Awaited<ReturnType<typeof listContracts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContractsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContracts>>> = ({ signal }) => listContracts(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listContracts>>>
export type ListContractsQueryError = unknown


export function useListContracts<TData = Awaited<ReturnType<typeof listContracts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContracts>>,
          TError,
          Awaited<ReturnType<typeof listContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContracts<TData = Awaited<ReturnType<typeof listContracts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContracts>>,
          TError,
          Awaited<ReturnType<typeof listContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContracts<TData = Awaited<ReturnType<typeof listContracts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List contracts for the caller's organisation
 */

export function useListContracts<TData = Awaited<ReturnType<typeof listContracts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContracts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListContractsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Create a standalone contract draft (partner's copy only) — no offer required
 */
export const createContract = (
    createContractRequest: CreateContractRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateContract200>(
      {url: `/api/v1/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractRequest, signal
    },
      );
    }
  


export const getCreateContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContract>>, TError,{data: CreateContractRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createContract>>, TError,{data: CreateContractRequest}, TContext> => {

const mutationKey = ['createContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContract>>, {data: CreateContractRequest}> = (props) => {
          const {data} = props ?? {};

          return  createContract(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateContractMutationResult = NonNullable<Awaited<ReturnType<typeof createContract>>>
    export type CreateContractMutationBody = CreateContractRequest
    export type CreateContractMutationError = unknown

    /**
 * @summary Create a standalone contract draft (partner's copy only) — no offer required
 */
export const useCreateContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContract>>, TError,{data: CreateContractRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContract>>,
        TError,
        {data: CreateContractRequest},
        TContext
      > => {

      const mutationOptions = getCreateContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Send the contract to the client — partner only; creates the client's copy
 */
export const sendContract = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<SendContract200>(
      {url: `/api/v1/contracts/${id}/send`, method: 'POST', signal
    },
      );
    }
  


export const getSendContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendContract>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendContract>>, TError,{id: string}, TContext> => {

const mutationKey = ['sendContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  sendContract(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendContractMutationResult = NonNullable<Awaited<ReturnType<typeof sendContract>>>
    
    export type SendContractMutationError = unknown

    /**
 * @summary Send the contract to the client — partner only; creates the client's copy
 */
export const useSendContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendContract>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendContract>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getSendContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reject a sent contract — client only, unless CON-09 client-initiated (then partner only)
 */
export const rejectContract = (
    id: string,
    rejectContractRequest: RejectContractRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<RejectContract200>(
      {url: `/api/v1/contracts/${id}/reject`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectContractRequest, signal
    },
      );
    }
  


export const getRejectContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectContract>>, TError,{id: string;data: RejectContractRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectContract>>, TError,{id: string;data: RejectContractRequest}, TContext> => {

const mutationKey = ['rejectContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectContract>>, {id: string;data: RejectContractRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  rejectContract(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectContractMutationResult = NonNullable<Awaited<ReturnType<typeof rejectContract>>>
    export type RejectContractMutationBody = RejectContractRequest
    export type RejectContractMutationError = unknown

    /**
 * @summary Reject a sent contract — client only, unless CON-09 client-initiated (then partner only)
 */
export const useRejectContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectContract>>, TError,{id: string;data: RejectContractRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectContract>>,
        TError,
        {id: string;data: RejectContractRequest},
        TContext
      > => {

      const mutationOptions = getRejectContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Renegotiate a line's price/quantity — closes the old line, opens a new versioned one
 */
export const addAddendum = (
    id: string,
    lineId: string,
    addendumRequest: AddendumRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AddAddendum200>(
      {url: `/api/v1/contracts/${id}/lines/${lineId}/addendum`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addendumRequest, signal
    },
      );
    }
  


export const getAddAddendumMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAddendum>>, TError,{id: string;lineId: string;data: AddendumRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof addAddendum>>, TError,{id: string;lineId: string;data: AddendumRequest}, TContext> => {

const mutationKey = ['addAddendum'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addAddendum>>, {id: string;lineId: string;data: AddendumRequest}> = (props) => {
          const {id,lineId,data} = props ?? {};

          return  addAddendum(id,lineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddAddendumMutationResult = NonNullable<Awaited<ReturnType<typeof addAddendum>>>
    export type AddAddendumMutationBody = AddendumRequest
    export type AddAddendumMutationError = unknown

    /**
 * @summary Renegotiate a line's price/quantity — closes the old line, opens a new versioned one
 */
export const useAddAddendum = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addAddendum>>, TError,{id: string;lineId: string;data: AddendumRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addAddendum>>,
        TError,
        {id: string;lineId: string;data: AddendumRequest},
        TContext
      > => {

      const mutationOptions = getAddAddendumMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Pause an ACTIVE contract — own copy only
 */
export const hold = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Hold200>(
      {url: `/api/v1/contracts/${id}/hold`, method: 'POST', signal
    },
      );
    }
  


export const getHoldMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hold>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hold>>, TError,{id: string}, TContext> => {

const mutationKey = ['hold'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hold>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  hold(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type HoldMutationResult = NonNullable<Awaited<ReturnType<typeof hold>>>
    
    export type HoldMutationError = unknown

    /**
 * @summary Pause an ACTIVE contract — own copy only
 */
export const useHold = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hold>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof hold>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getHoldMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Mark an ACTIVE contract as COMPLETED — own copy only
 */
export const complete = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Complete200>(
      {url: `/api/v1/contracts/${id}/complete`, method: 'POST', signal
    },
      );
    }
  


export const getCompleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{id: string}, TContext> => {

const mutationKey = ['complete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof complete>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  complete(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteMutationResult = NonNullable<Awaited<ReturnType<typeof complete>>>
    
    export type CompleteMutationError = unknown

    /**
 * @summary Mark an ACTIVE contract as COMPLETED — own copy only
 */
export const useComplete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof complete>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof complete>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCompleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Close a COMPLETED contract — own copy only
 */
export const closeContract = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CloseContract200>(
      {url: `/api/v1/contracts/${id}/close`, method: 'POST', signal
    },
      );
    }
  


export const getCloseContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeContract>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeContract>>, TError,{id: string}, TContext> => {

const mutationKey = ['closeContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  closeContract(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseContractMutationResult = NonNullable<Awaited<ReturnType<typeof closeContract>>>
    
    export type CloseContractMutationError = unknown

    /**
 * @summary Close a COMPLETED contract — own copy only
 */
export const useCloseContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeContract>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeContract>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCloseContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Cancel a contract (own copy only, either side, any non-terminal status)
 */
export const cancelContract = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CancelContract200>(
      {url: `/api/v1/contracts/${id}/cancel`, method: 'POST', signal
    },
      );
    }
  


export const getCancelContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelContract>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelContract>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelContract(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelContractMutationResult = NonNullable<Awaited<ReturnType<typeof cancelContract>>>
    
    export type CancelContractMutationError = unknown

    /**
 * @summary Cancel a contract (own copy only, either side, any non-terminal status)
 */
export const useCancelContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelContract>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelContract>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Mark an ACCEPTED or ON_HOLD contract as ACTIVE (execution begins) — own copy only
 */
export const activate = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Activate200>(
      {url: `/api/v1/contracts/${id}/activate`, method: 'POST', signal
    },
      );
    }
  


export const getActivateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{id: string}, TContext> => {

const mutationKey = ['activate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateMutationResult = NonNullable<Awaited<ReturnType<typeof activate>>>
    
    export type ActivateMutationError = unknown

    /**
 * @summary Mark an ACCEPTED or ON_HOLD contract as ACTIVE (execution begins) — own copy only
 */
export const useActivate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activate>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getActivateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Accept a sent contract — client only, unless CON-09 client-initiated (then partner only, goes straight to ACTIVE)
 */
export const acceptContract = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AcceptContract200>(
      {url: `/api/v1/contracts/${id}/accept`, method: 'POST', signal
    },
      );
    }
  


export const getAcceptContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptContract>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptContract>>, TError,{id: string}, TContext> => {

const mutationKey = ['acceptContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  acceptContract(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptContractMutationResult = NonNullable<Awaited<ReturnType<typeof acceptContract>>>
    
    export type AcceptContractMutationError = unknown

    /**
 * @summary Accept a sent contract — client only, unless CON-09 client-initiated (then partner only, goes straight to ACTIVE)
 */
export const useAcceptContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptContract>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptContract>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getAcceptContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Create a contract draft from an ACCEPTED offer (partner only) — copies content and lines
 */
export const createFromOffer = (
    offerId: string,
    createContractFromOfferRequest: CreateContractFromOfferRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateFromOffer200>(
      {url: `/api/v1/contracts/from-offer/${offerId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractFromOfferRequest, signal
    },
      );
    }
  


export const getCreateFromOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFromOffer>>, TError,{offerId: string;data: CreateContractFromOfferRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFromOffer>>, TError,{offerId: string;data: CreateContractFromOfferRequest}, TContext> => {

const mutationKey = ['createFromOffer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFromOffer>>, {offerId: string;data: CreateContractFromOfferRequest}> = (props) => {
          const {offerId,data} = props ?? {};

          return  createFromOffer(offerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFromOfferMutationResult = NonNullable<Awaited<ReturnType<typeof createFromOffer>>>
    export type CreateFromOfferMutationBody = CreateContractFromOfferRequest
    export type CreateFromOfferMutationError = unknown

    /**
 * @summary Create a contract draft from an ACCEPTED offer (partner only) — copies content and lines
 */
export const useCreateFromOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFromOffer>>, TError,{offerId: string;data: CreateContractFromOfferRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFromOffer>>,
        TError,
        {offerId: string;data: CreateContractFromOfferRequest},
        TContext
      > => {

      const mutationOptions = getCreateFromOfferMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary CON-09: client creates a contract draft from their own ACCEPTED offer copy — same DRAFT/razrada phase as the partner path, send() afterwards to propagate to the partner
 */
export const createContractFromOfferByClient = (
    offerId: string,
    createContractFromOfferByClientRequest: CreateContractFromOfferByClientRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<CreateContractFromOfferByClient200>(
      {url: `/api/v1/contracts/from-offer/${offerId}/by-client`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractFromOfferByClientRequest, signal
    },
      );
    }
  


export const getCreateContractFromOfferByClientMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractFromOfferByClient>>, TError,{offerId: string;data: CreateContractFromOfferByClientRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createContractFromOfferByClient>>, TError,{offerId: string;data: CreateContractFromOfferByClientRequest}, TContext> => {

const mutationKey = ['createContractFromOfferByClient'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractFromOfferByClient>>, {offerId: string;data: CreateContractFromOfferByClientRequest}> = (props) => {
          const {offerId,data} = props ?? {};

          return  createContractFromOfferByClient(offerId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateContractFromOfferByClientMutationResult = NonNullable<Awaited<ReturnType<typeof createContractFromOfferByClient>>>
    export type CreateContractFromOfferByClientMutationBody = CreateContractFromOfferByClientRequest
    export type CreateContractFromOfferByClientMutationError = unknown

    /**
 * @summary CON-09: client creates a contract draft from their own ACCEPTED offer copy — same DRAFT/razrada phase as the partner path, send() afterwards to propagate to the partner
 */
export const useCreateContractFromOfferByClient = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractFromOfferByClient>>, TError,{offerId: string;data: CreateContractFromOfferByClientRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContractFromOfferByClient>>,
        TError,
        {offerId: string;data: CreateContractFromOfferByClientRequest},
        TContext
      > => {

      const mutationOptions = getCreateContractFromOfferByClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Get a single contract
 */
export const getContract = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetContract200>(
      {url: `/api/v1/contracts/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getGetContractQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/${id}`
    ] as const;
    }

    
export const getGetContractQueryOptions = <TData = Awaited<ReturnType<typeof getContract>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContract>>> = ({ signal }) => getContract(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getContract>>>
export type GetContractQueryError = unknown


export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single contract
 */

export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update a contract's content — only while DRAFT or REJECTED, own copy only
 */
export const updateContract = (
    id: string,
    updateContractRequest: UpdateContractRequest,
 ) => {
      
      
      return apiClient<UpdateContract200>(
      {url: `/api/v1/contracts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateContractRequest
    },
      );
    }
  


export const getUpdateContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContract>>, TError,{id: string;data: UpdateContractRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContract>>, TError,{id: string;data: UpdateContractRequest}, TContext> => {

const mutationKey = ['updateContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContract>>, {id: string;data: UpdateContractRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  updateContract(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateContract>>>
    export type UpdateContractMutationBody = UpdateContractRequest
    export type UpdateContractMutationError = unknown

    /**
 * @summary Update a contract's content — only while DRAFT or REJECTED, own copy only
 */
export const useUpdateContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContract>>, TError,{id: string;data: UpdateContractRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContract>>,
        TError,
        {id: string;data: UpdateContractRequest},
        TContext
      > => {

      const mutationOptions = getUpdateContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Remove a line from a contract — only while DRAFT or REJECTED
 */
export const removeContractLine = (
    id: string,
    lineId: string,
 ) => {
      
      
      return apiClient<RemoveContractLine200>(
      {url: `/api/v1/contracts/${id}/lines/${lineId}`, method: 'DELETE'
    },
      );
    }
  


export const getRemoveContractLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeContractLine>>, TError,{id: string;lineId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeContractLine>>, TError,{id: string;lineId: string}, TContext> => {

const mutationKey = ['removeContractLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeContractLine>>, {id: string;lineId: string}> = (props) => {
          const {id,lineId} = props ?? {};

          return  removeContractLine(id,lineId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveContractLineMutationResult = NonNullable<Awaited<ReturnType<typeof removeContractLine>>>
    
    export type RemoveContractLineMutationError = unknown

    /**
 * @summary Remove a line from a contract — only while DRAFT or REJECTED
 */
export const useRemoveContractLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeContractLine>>, TError,{id: string;lineId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeContractLine>>,
        TError,
        {id: string;lineId: string},
        TContext
      > => {

      const mutationOptions = getRemoveContractLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Update a line's price/quantity — only while DRAFT or REJECTED
 */
export const updateContractLine = (
    id: string,
    lineId: string,
    updateContractLineRequest: UpdateContractLineRequest,
 ) => {
      
      
      return apiClient<UpdateContractLine200>(
      {url: `/api/v1/contracts/${id}/lines/${lineId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateContractLineRequest
    },
      );
    }
  


export const getUpdateContractLineMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractLine>>, TError,{id: string;lineId: string;data: UpdateContractLineRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateContractLine>>, TError,{id: string;lineId: string;data: UpdateContractLineRequest}, TContext> => {

const mutationKey = ['updateContractLine'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateContractLine>>, {id: string;lineId: string;data: UpdateContractLineRequest}> = (props) => {
          const {id,lineId,data} = props ?? {};

          return  updateContractLine(id,lineId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateContractLineMutationResult = NonNullable<Awaited<ReturnType<typeof updateContractLine>>>
    export type UpdateContractLineMutationBody = UpdateContractLineRequest
    export type UpdateContractLineMutationError = unknown

    /**
 * @summary Update a line's price/quantity — only while DRAFT or REJECTED
 */
export const useUpdateContractLine = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateContractLine>>, TError,{id: string;lineId: string;data: UpdateContractLineRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateContractLine>>,
        TError,
        {id: string;lineId: string;data: UpdateContractLineRequest},
        TContext
      > => {

      const mutationOptions = getUpdateContractLineMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Soft-delete a contract (own copy only)
 */
export const deactivateContract = (
    id: string,
 ) => {
      
      
      return apiClient<DeactivateContract200>(
      {url: `/api/v1/contracts/${id}/deactivate`, method: 'PATCH'
    },
      );
    }
  


export const getDeactivateContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateContract>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deactivateContract>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateContract>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateContract(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateContractMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateContract>>>
    
    export type DeactivateContractMutationError = unknown

    /**
 * @summary Soft-delete a contract (own copy only)
 */
export const useDeactivateContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateContract>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateContract>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Generate a basic PDF preview of the contract
 */
export const getContractPdf = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetContractPdf200>(
      {url: `/api/v1/contracts/${id}/pdf`, method: 'GET', signal
    },
      );
    }
  



export const getGetContractPdfQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/${id}/pdf`
    ] as const;
    }

    
export const getGetContractPdfQueryOptions = <TData = Awaited<ReturnType<typeof getContractPdf>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractPdfQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractPdf>>> = ({ signal }) => getContractPdf(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getContractPdf>>>
export type GetContractPdfQueryError = unknown


export function useGetContractPdf<TData = Awaited<ReturnType<typeof getContractPdf>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractPdf>>,
          TError,
          Awaited<ReturnType<typeof getContractPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractPdf<TData = Awaited<ReturnType<typeof getContractPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractPdf>>,
          TError,
          Awaited<ReturnType<typeof getContractPdf>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractPdf<TData = Awaited<ReturnType<typeof getContractPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Generate a basic PDF preview of the contract
 */

export function useGetContractPdf<TData = Awaited<ReturnType<typeof getContractPdf>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractPdf>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractPdfQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary AUD-01/AUD-02: header change history for this contract copy (not line changes)
 */
export const getContractHistory = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return apiClient<GetContractHistory200>(
      {url: `/api/v1/contracts/${id}/history`, method: 'GET', signal
    },
      );
    }
  



export const getGetContractHistoryQueryKey = (id?: string,) => {
    return [
    `/api/v1/contracts/${id}/history`
    ] as const;
    }

    
export const getGetContractHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getContractHistory>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractHistoryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractHistory>>> = ({ signal }) => getContractHistory(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getContractHistory>>>
export type GetContractHistoryQueryError = unknown


export function useGetContractHistory<TData = Awaited<ReturnType<typeof getContractHistory>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractHistory>>,
          TError,
          Awaited<ReturnType<typeof getContractHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractHistory<TData = Awaited<ReturnType<typeof getContractHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractHistory>>,
          TError,
          Awaited<ReturnType<typeof getContractHistory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractHistory<TData = Awaited<ReturnType<typeof getContractHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary AUD-01/AUD-02: header change history for this contract copy (not line changes)
 */

export function useGetContractHistory<TData = Awaited<ReturnType<typeof getContractHistory>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractHistory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractHistoryQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Paginated, filterable contract list for the main Contracts list page
 */
export const searchContracts = (
    params?: SearchContractsParams,
 signal?: AbortSignal
) => {
      
      
      return apiClient<PagedResponseContract>(
      {url: `/api/v1/contracts/search`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getSearchContractsQueryKey = (params?: SearchContractsParams,) => {
    return [
    `/api/v1/contracts/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchContractsQueryOptions = <TData = Awaited<ReturnType<typeof searchContracts>>, TError = unknown>(params?: SearchContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchContracts>>> = ({ signal }) => searchContracts(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchContractsQueryResult = NonNullable<Awaited<ReturnType<typeof searchContracts>>>
export type SearchContractsQueryError = unknown


export function useSearchContracts<TData = Awaited<ReturnType<typeof searchContracts>>, TError = unknown>(
 params: undefined |  SearchContractsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchContracts>>,
          TError,
          Awaited<ReturnType<typeof searchContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchContracts<TData = Awaited<ReturnType<typeof searchContracts>>, TError = unknown>(
 params?: SearchContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchContracts>>,
          TError,
          Awaited<ReturnType<typeof searchContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchContracts<TData = Awaited<ReturnType<typeof searchContracts>>, TError = unknown>(
 params?: SearchContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Paginated, filterable contract list for the main Contracts list page
 */

export function useSearchContracts<TData = Awaited<ReturnType<typeof searchContracts>>, TError = unknown>(
 params?: SearchContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchContracts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchContractsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




